import { ILogAppender, LogLevel, LogMessage, VelocityEvent, BaseAppender } from '@velociti/core'

export class ConsoleAppender extends BaseAppender implements ILogAppender {
  debug: (...args: LogMessage[]) => void = window.console.debug.bind(window.console)
  info: (...args: LogMessage[]) => void = window.console.log.bind(window.console)
  warn: (...args: LogMessage[]) => void = window.console.warn.bind(window.console)
  error: (...args: LogMessage[]) => void = window.console.error.bind(window.console)
  log: (...args: LogMessage[]) => void = window.console.log.bind(window.console)
  event: (...args: LogMessage[]) => void = window.console.log.bind(window.console)

  // debug(...args: LogMessage[]): void {
  //   window.console.debug(...args)
  // }
  // info(...args: LogMessage[]): void {
  //   window.console.info(...args)
  // }
  // warn(...args: LogMessage[]): void {
  //   window.console.warn(...args)
  // }
  // error(...args: LogMessage[]): void {
  //   window.console.error(...args)
  // }
  // log(...args: LogMessage[]): void {
  //   window.console.log(...args)
  // }
  // event(...args: VelocityEvent[]): void {
  //   window.console.log(...args)
  // }

  clear(): void {
    window.console.clear()
  }
  getAll(): LogMessage[] {
    return []
  }
}
